/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Text,
  VStack,
  Select,
  Heading,
  useColorModeValue
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { DEPARTMENTS } from "../../constants/departments";
import AdminNavTop from "../AdminNavTop";
import { useDispatch } from "react-redux";
import { addUser } from "../../Redux/AdminReducer/action";
import { useNavigate } from "react-router-dom";
import { useModalToast } from "../../context/GlobalModalToast";

const AddUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toast } = useModalToast();

  const [detail, setDetail] = useState({
    name: "",
    email: "",
    password: "",
    role: "employee",
    department: "Global",
    nationality: "Global",
    gender: "",
    companyId: "",
    companyName: ""
  });

  const [nationalities, setNationalities] = useState([]);
  const [companies, setCompanies] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem('user')) || {};
  const isSuperAdmin = currentUser.role === 'super_admin';

  useEffect(() => {
    // Fetch nationalities list from backend
    const fetchNationalities = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/nationalities`);
        setNationalities(res.data);
      } catch (err) {
        console.error("Failed to load nationalities", err);
      }
    };
    // Fetch companies list from backend if Superadmin
    const fetchCompanies = async () => {
      try {
        const token = currentUser.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/companies`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCompanies(res.data);
      } catch (err) {
        console.error("Failed to load companies", err);
      }
    };
    fetchNationalities();
    if (isSuperAdmin) {
      fetchCompanies();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!detail.name || !detail.email || !detail.password) {
      toast({ title: "Missing Fields", description: "Please fill in all required fields.", status: "warning" });
      return;
    }
    dispatch(addUser(detail));
    toast({ title: "User Added Successfully", status: "success", duration: 2000 });
    navigate("/admin/users");
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");
  const cardBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const textSub = useColorModeValue("gray.700", "gray.300");
  const cardBorder = useColorModeValue("gray.100", "rgba(255, 255, 255, 0.08)");
  const inputBg = useColorModeValue("white", "rgba(15, 23, 42, 0.5)");

  return (
    <Grid className="Nav" h={"99vh"} w="94%" gap={10} bg={bgMain} color={textMain}>
      <Box mt="90px">
        <AdminNavTop />

        <Box
          className="glass-card"
          borderRadius="2xl"
          p={8}
          bg={cardBg}
          boxShadow="var(--shadow-premium)"
          maxW="600px"
          mx="auto"
          border="1px solid"
          borderColor={cardBorder}
        >
          <Heading size="md" mb={6} color={textMain} fontWeight="800">
            👥 Add Corporate Employee
          </Heading>

          <VStack spacing={5} align="stretch">
            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Employee Full Name</FormLabel>
              <Input
                type="text"
                placeholder="Enter Name of Employee"
                name="name"
                value={detail.name}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Corporate Email Address</FormLabel>
              <Input
                type="email"
                placeholder="employee@company.com"
                name="email"
                value={detail.email}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Password</FormLabel>
              <Input
                type="password"
                placeholder="Temporary Account Password"
                name="password"
                value={detail.password}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Corporate Role</FormLabel>
              <Select
                name="role"
                value={detail.role}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="employee">Employee</option>
                <option value="instructor">Instructor</option>
                <option value="admin">Administrator</option>
              </Select>
            </FormControl>



            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Department / Sector</FormLabel>
              <Select
                name="department"
                value={detail.department}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                {DEPARTMENTS.map((dept) => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Nationality</FormLabel>
              <Select
                name="nationality"
                value={detail.nationality}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="Global">Global</option>
                {nationalities.map((nat) => (
                  <option key={nat._id} value={nat.name}>{nat.name}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Gender</FormLabel>
              <Select
                name="gender"
                value={detail.gender}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </Select>
            </FormControl>

            {isSuperAdmin && (
              <FormControl isRequired>
                <FormLabel fontWeight="600" color={textSub} fontSize="sm">Company / Branch</FormLabel>
                <Select
                  name="companyId"
                  value={detail.companyId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedComp = companies.find(c => c.companyId === selectedId);
                    setDetail(prev => ({
                      ...prev,
                      companyId: selectedId,
                      companyName: selectedComp ? selectedComp.companyName : ""
                    }));
                  }}
                  borderRadius="xl"
                  bg={inputBg}
                  placeholder="Select Corporate Branch"
                >
                  {companies.map((comp) => (
                    <option key={comp.companyId} value={comp.companyId}>
                      {comp.companyName} ({comp.companyId})
                    </option>
                  ))}
                </Select>
              </FormControl>
            )}

            <Button
              mt={4}
              className="premium-gradient hover-lift"
              color="white"
              size="lg"
              w="full"
              borderRadius="xl"
              onClick={handleSubmit}
            >
              Add Employee
            </Button>
          </VStack>
        </Box>
      </Box>
    </Grid>
  );
};

export default AddUser;
